import React, { useEffect } from 'react';
import { useNavigate } from "react-router-dom"
import { roles } from './utils/constants';
import { useLocation, useParams } from 'react-router'
import API from './services/api';

function GuardedRoute(props) {
  const { Component } = props;
  const navigate = useNavigate()
  const {id} = useParams()
  const location = useLocation()
  if(id)
   {
    const match = location.pathname.match(/^(\/[^/]+\/[^/]+)/); // Matches the first two segments
    const basePath = match ? match[1] : location.pathname;
    if(basePath === '/home/slotbooking'){
      localStorage.setItem('slot-id', id)
    }
    else if(basePath === '/home/checker')
    { 
      console.log("iam here");
      localStorage.setItem('mc_id',id);
    }
    else{
      localStorage.setItem('discount-obj', id)
    }
    }
  
  useEffect(() => {
    if (!localStorage.getItem("token") ) {
      localStorage.removeItem("token")
      localStorage.removeItem("role")
      localStorage.removeItem('salesTabFlag')
      localStorage.removeItem('type')
      localStorage.removeItem("main_user")
      localStorage.removeItem("sales_team")
      localStorage.removeItem('mc_role')
      navigate("/")
    }
    const role = localStorage.getItem("role")
    if (role !== roles.salesperson && role !== roles.advertiser && role !== roles.ops && role !== roles.financer && role !== roles.network_ad_manager && role !== roles.b2b && role !== roles.legalperson && role !== roles.designer && role!== roles.content_writer && role !== roles.vendor_admin) {
      localStorage.removeItem("token")
      localStorage.removeItem("role")
      localStorage.removeItem('salesTabFlag')
      localStorage.removeItem('type')
      localStorage.removeItem("main_user")
      localStorage.removeItem("sales_team")
      localStorage.removeItem('mc_role')
      navigate("/")
    }

  })
  useEffect(() => {
    const mcRole = localStorage.getItem('role');
     if([roles.b2b,roles.financer,roles.ops].includes(mcRole)){
        const fetchUserRole = async(url) =>{
            let res = await API({
                url: url,
                method: "POST",
                responseType: "json",
            });
            if(res.status==='SUCCESS' && res.data){
               localStorage.setItem('mc_role',res.data.mc_role)
            }
        }
        if(mcRole===roles.b2b || mcRole === roles.ops){
            fetchUserRole('/user/b2b_team/getUserRole');
        }else if(mcRole===roles.financer){
            fetchUserRole('/user/finance_team/getUserRole');
        }
     }else{
           localStorage.removeItem('mc_role')
      }
  },[localStorage.getItem('role')])
  return (
    <>
    
    <Component />
    </>
  )
}

export default GuardedRoute;